import React from "react";
import { withAppLayout } from "../../../hoc";
import { ManageDistributionProvider } from "../../../contexts";
import { LoanRequestContainer } from "../../../containers";
const LoanRequest = (props) => {
  return (
    // <ManageDistributionProvider>
    <LoanRequestContainer {...props} />
    // </ManageDistributionProvider>
  );
};

export default LoanRequest;
